import { Typography, Box } from '@mui/material';
import { format, parseISO } from 'date-fns';
import { FC } from 'react';

interface IDateDisplay {
	date: string;
	description: string;
}

export const toDisplayTime = (date: string) => {
	const parsedDate = parseISO(date);
	return format(parsedDate, 'HH:mm');
};

export const toDisplayDay = (date: string) => {
	const parsedDate = parseISO(date);
	return format(parsedDate, 'dd MMM');
};

export const toDisplayYear = (date: string) => {
	const parsedDate = parseISO(date);
	return format(parsedDate, 'yyyy');
};

const DateDisplay: FC<IDateDisplay> = ({ date, description }) => {
	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'row',
				alignItems: 'center',
				width: '100%',
			}}
		>
			<Box>
				<Box sx={{ pr: 2 }}>
					<Typography sx={{ fontSize: 14, mb: 1 }}>{description}</Typography>
					<Typography sx={{ fontSize: 14 }}>{toDisplayDay(date)}</Typography>
					<Typography sx={{ fontSize: 30, fontWeight: 'bold', lineHeight: 1 }}>{toDisplayYear(date)}</Typography>
					<Typography sx={{ fontSize: 14 }}>{toDisplayTime(date)} </Typography>
				</Box>
			</Box>
		</Box>
	);
};

export default DateDisplay;
